export const START_CONNECTIONS_GAME_COMPLETED = "driversConnections/startGameCompleted";
export const VALIDATE_CONNECTIONS_GROUP_COMPLETED = "driversConnections/validateGroupCompleted";
export const REVEAL_CONNECTIONS_ANSWERS_COMPLETED = "driversConnections/revealAnswersCompleted";
export const CLEAR_VALIDATION_RESULT = "driversConnections/clearValidationResult";
